export default __webpack_public_path__ + "static/media/resource.edcbe5f5.svg";